import * as api from "../api/admin.js";

export const sendEmails = async (emailData, customersToEmail, additional, token, callback) => {
    const { data } = await api.sendEmails(emailData, customersToEmail, additional, token);
    callback(data);
};
